import React, { Suspense } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import toast from "react-hot-toast";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

//MUI components
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";

//Custom components
import { AppWrapper } from "./components/layout/layout.components";
import Loader from "./components/common/Loader/Loader.component";
import Toast from "./components/common/Toast/Toast.component";
// import ErrorBoundary from "./components/common/DefaultErrorBoundary/DefaultErrorBoundary.component";

//pages
import PageBegin from "./pages/authenticated/Home/Home.page";
import PageEntity from "./pages/authenticated/Entity/Entity.page";
import PageFile from "./pages/authenticated/File/File.page"
import PageNotFound from "./pages/common/NotFound.page";
import PageLanding from "./pages/common/Landing.page";

//Utils
import theme from "./styles/theme";

//context
import { AuthProvider } from "./context/auth";
import { PageErrorProvider } from "./context/pageError";
import { CategoriesProvider } from "./context/categories";

//i18n
import "./utils/i18n";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      onError: (error: any) => {
        toast.error(error?.message || "Something went wrong.");
      },
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      cacheTime: 0,
      enabled: false,
    },
    mutations: {
      retry: false,
      // cacheTime: 0,
      onError: (e: any) => {
        toast.error(e.response?.data?.message || "Something went wrong.");
      },
    },
  },
});

//router
const routes = createBrowserRouter([
  {
    path: "*",
    element: (
      <AppWrapper>
        <PageNotFound />
      </AppWrapper>
    ),
  },
  {
    path: "/",
    element: <PageLanding />,
    children: [
      {
        path: "/",
        element: (
          <AppWrapper>
            <PageBegin />
          </AppWrapper>
        ),
      },
      {
        path: "/categories/:id/:folderId",
        element: (
          <AppWrapper>
            <PageEntity />
          </AppWrapper>
        ),
      },
      {
        path: "/categories/:id",
        element: (
          <AppWrapper>
            <PageEntity />
          </AppWrapper>
        ),
      },
      {
        path: "/file/:fileId",
        element: (
          <AppWrapper>
            <PageFile />
          </AppWrapper>
        ),
      },
    ],
  },
]);

function App() {
  return (
    // <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<Loader />}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AuthProvider>
            <CategoriesProvider>
              <PageErrorProvider>
                <RouterProvider router={routes} />
              </PageErrorProvider>
            </CategoriesProvider>
          </AuthProvider>
          <Loader />
        </ThemeProvider>
      </Suspense>
      <Toast />
    </QueryClientProvider>
    // </ErrorBoundary>
  );
}

export default App;
